import { WhatsApp } from "@/icons/WhatsApp.tsx";
import { FC } from "react";

interface WhatsAppShareProps {
  text?: string;
  url?: string;
  onError?: () => void;
}

export const WhatsAppShareButton: FC<WhatsAppShareProps> = ({
  text,
  url,
  onError,
}) => {
  const handleShare = () => {
    try {
      const shareText = text ? encodeURIComponent(text) : "";
      const shareUrl = url ? encodeURIComponent(url) : "";

      const whatsappContent =
        shareText && shareUrl
          ? `${shareText} ${shareUrl}`
          : shareText || shareUrl;

      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      const baseUrl = isMobile
        ? "whatsapp://send"
        : "https://api.whatsapp.com/send";

      const whatsappUrl = `${baseUrl}?text=${whatsappContent}`;

      // Create a timeout to detect if the app didn't open
      const timeout = setTimeout(() => {
        if (onError) {
          onError();
        }
      }, 2500);

      window.open(whatsappUrl, "_blank");

      // Clear the timeout if the window loses focus (meaning the app opened)
      window.onblur = () => {
        clearTimeout(timeout);
      };
    } catch (error) {
      if (onError) {
        onError();
      }
    }
  };

  return (
    <button
      style={{ backgroundColor: "#25D366" }}
      className="fill-white rounded-full w-8 h-8 flex items-center justify-center"
      onClick={handleShare}
      aria-label="Share on WhatsApp"
    >
      <WhatsApp size={18} />
    </button>
  );
};
